import { FaCompass, FaFlagCheckered } from "react-icons/fa";
import styles from "./Section1.module.css";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: <FaCompass />,
    label: "Our Mission",
    text: "We're dedicated to offering high-quality RCM solutions, improving physicians' income, increasing cash flow, and aligning with business norms. Our goal is to be more than just a service provider. We strive to be your ally in success.",
    tone: "missionCard",
  },
  {
    icon: <FaFlagCheckered />,
    label: "Our Vision",
    text: "We see a future where healthcare providers succeed through strong, long-lasting partnerships. By always improving our services, we aim to be the trusted financial advisor for all providers, so they can focus on giving great care and improving our community's wellness.",
    tone: "visionCard",
  },
];

export default function Section1() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.shell}`}>
        <div className={styles.intro}>
          <span className={styles.kicker}>
            Electronic Medical Billing Services
          </span>
          <h2>
            Electronic Medical Billing Services <br /> by Physicians Success
            Partners
          </h2>
          <p>
            We improve medical billing with advanced electronic solutions that
            replace outdated systems and streamline revenue cycle management
            (RCM). Our services include coding, claims processing, payment
            posting, and{" "}
            <Link to="services/account-receivables">
              A/R management for all physician specialties
            </Link>
            , ensuring faster payments, fewer denials, better cash flow, and
            full HIPAA compliance. Physicians Success Partners provides
            complete, efficient billing solutions to enhance your practice’s
            financial performance.
          </p>
        </div>

        <div className={styles.cardsGrid}>
          {cards.map((card) => (
            <article
              key={card.label}
              className={`${styles.card} ${styles[card.tone]}`}
            >
              <div className={styles.cardIcon}>{card.icon}</div>
              <h3>{card.label}</h3>
              <p>{card.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
